"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const outline_1 = require("@heroicons/react/outline");
const elements_ui_components_icon_button_1 = __importDefault(require("@hydrogen/elements.ui.components.icon-button"));
const elements_ui_icon_1 = __importStar(require("@hydrogen/elements.ui.icon"));
const NavListDialog_1 = __importDefault(require("./NavListDialog"));
const ProfileInfo_1 = __importDefault(require("./ProfileInfo"));
const MobileNavBar = ({ navigations = [], menuItems = [], profileInfo = null, logoSrc = null, logoLink = '', logoSvg = null, }) => {
    const [more, setMore] = (0, react_1.useState)(false);
    if (!(navigations === null || navigations === void 0 ? void 0 : navigations.length) && !(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length))
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(elements_ui_components_icon_button_1.default, { onClick: () => setMore(true) },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: "sr-only" }, "Open main menu"),
                react_1.default.createElement(elements_ui_icon_1.default, { icon: more ? outline_1.XIcon : outline_1.MenuIcon, className: "block", size: elements_ui_icon_1.IconsSizes.medium }))),
        react_1.default.createElement(NavListDialog_1.default, { logoSrc: logoSrc, logoSvg: logoSvg, logoLink: logoLink, show: more, navigations: navigations, onClose: () => setMore(false) },
            react_1.default.createElement(ProfileInfo_1.default, { classNamePanel: "bg-transparent", profileInfo: profileInfo, menuItems: menuItems }))));
};
exports.default = MobileNavBar;
//# sourceMappingURL=MobileNavBar.js.map